import { render, staticRenderFns } from "./contactListSetting.vue?vue&type=template&id=57e12c54&scoped=true"
import script from "./contactListSetting.vue?vue&type=script&lang=js"
export * from "./contactListSetting.vue?vue&type=script&lang=js"
import style0 from "./contactListSetting.vue?vue&type=style&index=0&id=57e12c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e12c54",
  null
  
)

export default component.exports